import React from 'react'
import { Card as MuiCard, CardContent as MuiCardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'

// CommonCard component with same styling as other reading components
const CommonCard = ({ children, sx = {} }: { children: React.ReactNode; sx?: any }) => (
  <MuiCard
    sx={{
      bgcolor: 'rgba(255, 255, 255, 0.7)',
      backdropFilter: 'blur-sm',
      border: '0.5px solid rgba(201, 173, 167, 0.4)',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      transition: 'all 200ms',
      marginBottom: 8,
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      },
      ...sx
    }}
  >
    {children}
  </MuiCard>
)

interface ConclusionSectionProps {
  conclusion?: string
}

export default function ConclusionSection({ conclusion }: ConclusionSectionProps) {
  const { t } = useTranslation()

  if (!conclusion) {
    return null
  }

  return (
    <section aria-labelledby="conclusion-heading">
      <h2
        id="conclusion-heading"
        className="text-lg font-['Playfair_Display'] text-[#2B2E4A] font-semibold mb-4 mt-0"
      >
        {t('readingPage.conclusion')}
      </h2>
      <CommonCard sx={{ mb: 6 }}>
        <MuiCardContent sx={{ p: 3 }}>
          <div className="flex flex-col gap-1">
            {conclusion
              .split('.')
              .filter((sentence: string) => sentence.trim())
              .map((sentence: string, index: number) => (
                <p
                  key={index}
                  className="text-md leading-relaxed text-[#2B2E4A]/70 font-['Plus_Jakarta_Sans'] mb-5"
                >
                  {sentence.trim()}.
                </p>
              ))}
          </div>
        </MuiCardContent>
      </CommonCard>
    </section>
  )
}
